const DISMISS_KEY = "fairshare_dismissed_announcements";

export function readDismissedAnnouncementIds() {
    try {
        const raw = localStorage.getItem(DISMISS_KEY);
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        return new Set(Array.isArray(parsed) ? parsed : []);
    } catch (_e) {
        return new Set();
    }
}

export function dismissAnnouncement(id) {
    if (!id) return;
    const next = readDismissedAnnouncementIds();
    next.add(id);
    localStorage.setItem(DISMISS_KEY, JSON.stringify([...next]));
}

export function toDatetimeLocalValue(iso) {
    if (!iso) return "";
    try {
        const date = new Date(iso);
        if (Number.isNaN(date.getTime())) return "";
        const pad = (n) => String(n).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    } catch (_e) {
        return "";
    }
}

export function fromDatetimeLocalValue(value) {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString();
}

export function announcementStatusLabel(status) {
    switch (status) {
        case "active":
            return "Live";
        case "scheduled":
            return "Scheduled";
        case "expired":
            return "Expired";
        case "disabled":
            return "Disabled";
        default:
            return status || "Unknown";
    }
}

export function announcementStatusClass(status) {
    switch (status) {
        case "active":
            return "text-emerald-400 border-emerald-500/25 bg-emerald-500/10";
        case "scheduled":
            return "text-sky-300 border-sky-500/25 bg-sky-500/10";
        case "expired":
            return "text-white/45 border-white/10 bg-white/[0.03]";
        case "disabled":
            return "text-white/45 border-white/10 bg-white/[0.03]";
        default:
            return "text-white/55 border-white/10 bg-white/[0.03]";
    }
}

export const ANNOUNCEMENT_SEVERITIES = [
    { value: "info", label: "Info" },
    { value: "warning", label: "Warning" },
    { value: "critical", label: "Critical" },
];

export const ANNOUNCEMENT_AUDIENCES = [
    { value: "all", label: "Everyone" },
    { value: "app", label: "App only" },
    { value: "admin", label: "Admin console only" },
    { value: "auth", label: "Login & registration only" },
];

export function emptyAnnouncement() {
    return {
        id: null,
        enabled: true,
        title: "",
        message: "",
        severity: "info",
        link_url: "",
        link_label: "",
        starts_at: "",
        ends_at: "",
        dismissible: true,
        audience: "all",
    };
}
